<template>
  <div id="app">
    <el-backtop></el-backtop>
    <div
      class="app"
      v-if="$store.state.isMobile"
      style="margin: 0; padding: 0">
      <div class="app_boox">
        <div class="app_root">
          <van-nav-bar title="Fibroin">
            <template #left>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <img
                    src="../src/assets/下拉菜单.png"
                    style="width: 20px" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- 首页 -->
                  <el-dropdown-item command="a">{{ $store.state.language ? "บ้าน" : "首页" }} </el-dropdown-item>
                  <!-- 防伪接口 -->
                  <!-- <el-dropdown-item command="b">{{ $store.state.language ? "ประวัติแบรนด" : "防伪接口" }} </el-dropdown-item> -->

                  <!-- 品牌历史  -->
                  <!-- <el-dropdown-item command="c">{{ $store.state.language ? "เส้นทางของแบรนด์" : "品牌历程" }} </el-dropdown-item> -->
                  <!-- 菲必丽百科词条  -->
                  <el-dropdown-item command="d">{{ $store.state.language ? "เกี่ยวกับฟิปิริ" : "关于菲必丽" }} </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template #right>
              <img
                src="../src/assets/语种=泰语.png"
                style="width: 25px; height: 25px"
                @click="zt()" />
            </template>
          </van-nav-bar>
        </div>
      </div>
      <el-backtop
        target=".page-component__scroll .el-scrollbar__wrap"
        :bottom="100">
        <div
          style="
             {
              height: 100%;
              width: 100%;
              background-color: #f2f5f6;
              box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
              text-align: center;
              line-height: 40px;
              color: #1989fa;
            }
          ">
          UP
        </div>
      </el-backtop>

      <router-view />
    </div>

    <div
      class="pc"
      v-else>
      
    <div v-if="imagesLoaded">
      <div  v-if="!isFixed" >
        <div class="pcRoot">
          <van-nav-bar title="Fibroin" class="Fibroin">
            <template #title>
              <h1 class="Fibroin">Fibroin </h1>
              
            </template>
            <template #right>
              <img
                src="../src/assets/语种=泰语.png"
                style="width: 25px; height: 25px"
                @click="zt()" />
            </template>
          </van-nav-bar>
          <el-row>
             <el-col :span="6"></el-col>
             <el-col :span="12"
              ><div class="grid-content bg-purple-dark">
                <el-row>
  <el-col :span="4"><div   @click="handleSelect(1)"  class="grid-content bg-purple">
    {{ $store.state.language ? "บ้าน" : "首页" }}
  </div></el-col>
  <el-col :span="4"><div   @click="handleSelect(1.2)"  class="grid-content bg-purple">
    {{ $store.state.language ? "แนะนำผลิตภัณฑ์" : "产品推荐" }}
  </div></el-col>
  <el-col :span="4"><div   @click="handleSelect(1.3)"  class="grid-content bg-purple">
    {{ $store.state.language ? "งานฝีมือ" : "制作工艺" }}
  </div></el-col>
  <el-col :span="4" ><div @click="handleSelect(4)" class="grid-content bg-purple-light">
    {{ $store.state.language ? "เกี่ยวกับฟิปิริ" : "关于菲必丽" }}
  </div></el-col>
  <el-col :span="4" ><div @click="handleSelect(4.2)" class="grid-content bg-purple-light">
    {{ $store.state.language ? "รายละเอียดสินค้า" : "产品详情" }}
  </div></el-col>
  <el-col :span="4" ><div @click="handleSelect(1.4)" class="grid-content bg-purple-light">
    {{ $store.state.language ? "ติดต่อเรา" : "联系我们" }}
  </div></el-col>
  <!-- <el-menu-item index="1.4">{{ $store.state.language ? "ติดต่อเรา" : "联系我们" }}</el-menu-item> -->
  <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple-light"></div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple-light"></div></el-col>
</el-row>
             
              </div></el-col
            >
             <el-col :span="6"></el-col>
   
          </el-row>
        </div>
      </div>
      <div  v-else>
        <div class="pcRoot">
          <van-nav-bar  class="boxdsd">
            <template #title>
              <!-- <h1 class="Fibroin"> </h1> -->
              <!-- <h2>Fibroin</h2> -->
              <el-menu
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  :data-mode="currentPath"
                  @select="handleSelect">
                  <el-menu-item index="1">{{ $store.state.language ? "บ้าน" : "首页" }}</el-menu-item>
                  <el-menu-item index="1.2">{{ $store.state.language ? "แนะนำผลิตภัณฑ์" : "产品推荐" }}</el-menu-item>
                  <el-menu-item index="1.3">{{ $store.state.language ? "งานฝีมือ" : "制作工艺" }}</el-menu-item>
                  <!-- <el-menu-item index="2">{{ $store.state.language ? "ประวัติแบรนด" : "防伪接口" }} </el-menu-item> -->
                  <!-- <el-menu-item index="3">{{ $store.state.language ? "เส้นทางของแบรนด์" : "品牌历程" }} </el-menu-item> -->
                  <el-menu-item index="4">{{ $store.state.language ? "เกี่ยวกับฟิปิริ" : "关于菲必丽" }}</el-menu-item>
                  <el-menu-item index="4.2">{{ $store.state.language ? "รายละเอียดสินค้า" : "产品详情" }}</el-menu-item>
                  <el-menu-item index="1.4">{{ $store.state.language ? "ติดต่อเรา" : "联系我们" }}</el-menu-item>
                  <!-- <el-menu-item index="5"> <img
                src="../src/assets/语种=泰语.png"
                style="width: 25px; height: 25px"
                @click="zt()" /></el-menu-item> -->
                </el-menu>
            </template>
            <template #left>
              
            </template>
            <template #right>
              <img
                src="../src/assets/语种=泰语.png"
                style="width: 25px; height: 25px"
                @click="zt()" />
            </template>
          </van-nav-bar>
        
        </div>
      </div>
      <div class="HomeBoxdddd" :class="ifInp ? 'HomeBoxddddBuroo':''">
      <el-carousel :interval="4000" height="75vh">
			<el-carousel-item v-for="(item, index) in swiper" :key="index" >
        <el-image :src="item "  style="width: 100%; ;" alt="cover" /></el-carousel-item>

      </el-carousel>

      <div class="homeTime" v-if="ifInp">
			<el-card class="box-card">
  <div class="text item">
    <div>
      <h1>{{ $store.state.language ? 'Fibroin':'菲必丽' }}</h1> 
    </div>
    <!-- <hr> -->
     <h4>
  {{ $store.state.language ? 'Section : : : : การลงทะเบียนในประเทศไทย.Fibroin เป็นผู้ดูแลผิวหนัง ที่มีชื่อเสียงในประเทศไทยส่วนใหญ่แผนกดูแลผิว ที่เข้มข้น':'泰国皇家医药有限公司旗下品牌，1996年在泰国成立，2019年在中国申请注册菲必丽是泰国知名护肤品牌，主要深研护肤领域' }}
     </h4>
  
   
  </div>
</el-card>
<!-- <hr> -->
<el-card class="box-card">
  <div class="text item secar">
    <el-autocomplete
      class=" secarItem"
      v-model="input2"
      :fetch-suggestions="querySearch"
     :placeholder=" $store.state.language ? 'Please enter the content.':'请输入内容' "
      @select="querySearchGpull(input2)"
      clearable
    >
    <template slot="append"> <el-button slot="append" icon="el-icon-search" @click="querySearchGpull(input2)"></el-button></template>
  </el-autocomplete>
    <!-- <el-input :placeholder=" $store.state.language ? 'Please enter the content.':'请输入内容' " v-model="input2" class="secarItem">
    <template slot="append"> <el-button slot="append" icon="el-icon-search" @click="sevNav(input2)"></el-button></template>
  </el-input> -->
  </div>
</el-card>
		</div>
    </div>

      <!-- {{ currentPath }} -->
        <div class="hoemBox">
          <router-view />
        </div>
        <div class="footer">
      <div style="margin-left: 30px; margin-top: 20px">
        <h3>ติดต่อเรา</h3>
        <p>ฝ่ายลูกค้าสัมพันธ์ โทร: (+66) 2 392 2845</p>
        
        <p>Email : fibroin1996@gmail.com ,<br>
          customerservice@karmakamet.co.th</p>
        <p>Line Official: @karmakametworld</p>
        <p>ร้าน : แขวง คลองตันเหนือ, เขตวัฒนา,</p>
      </div>
      <hr style="width: 100%" />

      <!-- <hr style="width: 100%" /> -->
     
      <p>2024 Fibroin ALL RIGHT RESEVRED</p>
      <span style="margin-right: 15px"
        ><img
          src="@/assets/ghl.png"
          width="50px"
      /></span>
      <span style="margin-right: 15px"
        ><img
          src="@/assets/DBD.webp"
          width="50px"
      /></span>
      <span style="margin-right: 15px"
        ><img
          src="@/assets/dhl.webp"
          width="60px"
      /></span>
      <span style="margin-right: 15px"
        ><img
          src="@/assets/wsdk.webp"
          width="40px"
      /></span>
      <span style="margin-right: 15px"
        ><img
          src="@/assets/visa.webp"
          width="70px"
      /></span>
    </div>
    </div>
    <div v-else  v-loading="!imagesLoaded">
      <p>
        กำลังโหลดอยู่โปรดรอสักครู่....
      </p>
     
    </div>

  
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ImageList:[],
      imagesLoadedCount: 0,
      imagesLoaded: false,
      imageLoadFallbackTimer: null,
      isFixed: false,
      activeIndex: "1",
      ifInp:true,
      input2:'',
      goodsActive:-1,
      kemiImageList:[],
    
      swiper: [
				"/fibroin/lunbotu/微信图片_20250426140810.jpg",
				"/fibroin/lunbotu//微信图片_20250426142653 copy.jpg",
				// "/zmc/轮播图/微信图片_20250418142509.jpg",
				// "/zmc/轮播图/微信图片_20250418142516.jpg",
				// "/legacy-upload/lbt20250415131804.jpg",
				// "/legacy-upload/5e86e89d8a22a.jpg",
				// "/legacy-upload/62455ef9911c4.jpg",
				// "/legacy-upload/5e265dd9d017f.jpg"
			],
    };
  },
  created(){
    // console.log("什么东西",this.$store.state.kemiImageList);
    this.kemiImageList = this.$store.state.kemiImageList;
    
  },
  watch:{
    $route(to, from){
      if(to.path == '/home' || to.path == '/' || to.path == '/pc/home'|| JSON.stringify(to.path).includes('app')){
      this.ifInp = true;
    }else{
      this.ifInp = false;
      setTimeout(()=>{
          window.scrollTo({
           top:600,
          left:0,
          behavior: "smooth"
        });
        },500)
    }
            console.log('路由变化了')
            console.log('当前页面路由：' + to.path);
            
            console.log('上一个路由：' + from);
           
        },


  },
  mounted() {
    this.ImageList = [...this.swiper];
    this.ImageList.push(this.kemiImageList[0]);
    this.ImageList = this.ImageList.filter(Boolean);
    if (this.ImageList.length === 0) {
      this.imagesLoaded = true;
    } else {
      this.ImageList.forEach((image, index) => {
        const img = new Image();
        img.src = image;
        img.onload = () => {
          this.onImageLoad(index);
        };
        // 单张图片异常时也继续进入首页，避免永久卡在 loading。
        img.onerror = () => {
          console.warn("首页预加载图片失败：", image);
          this.onImageLoad(index);
        };
      });

      // 即使上游图片服务器暂时异常，也不要让 PC 首页永久转圈。
      this.imageLoadFallbackTimer = setTimeout(() => {
        if (!this.imagesLoaded) {
          console.warn("首页图片预加载超时，跳过等待");
          this.imagesLoaded = true;
        }
      }, 10000);
    }
    // console.log("路由变化了", this.currentPath);
    window.addEventListener("scroll", this.handleScroll);
    this.setIskeyPath();
    // this.setBackgckImage()
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.imageLoadFallbackTimer) {
      clearTimeout(this.imageLoadFallbackTimer);
    }
  },
  methods: {
    fetchSuggestions(){

    },
    querySearch(queryString, cb){

      var restaurants = [
      {
          address:'* Fibroin ยาสีฟันขาวสูตรวิจัยพิเศษ',
          value:'* Fibroin ยาสีฟันขาวสูตรวิจัยพิเศษ'
        },
          {
          address:'* Fibroin ยาสีฟันป้องกันฟันผุ สูตรวิจัยพิเศษ',
          value:'* Fibroin ยาสีฟันป้องกันฟันผุ สูตรวิจัยพิเศษ'
        },
        {
          address:'* Fibroin หน้ากากดูแลความชุ่มชื้นเด็กสีเงิน ',
          value:'* Fibroin หน้ากากดูแลความชุ่มชื้นเด็กสีเงิน ',
        },
        {
          address:'* Fibroin หน้ากากใบหน้าเด็กสีทอง Waterlight',
          value:'* Fibroin หน้ากากใบหน้าเด็กสีทอง Waterlight',
        },
        {
          address: '* Fibroin มาสก์หน้าชุ่มชื้นสีฟ้าสำหรับเด็ก',
          value: '* Fibroin มาสก์หน้าชุ่มชื้นสีฟ้าสำหรับเด็ก',
        },
        {
          address:'* Fibroin หน้ากากใบหน้าเด็กสีแดงน้ำ',
          value:'* Fibroin หน้ากากใบหน้าเด็กสีแดงน้ำ',
        },
        {
          address: '* Fibroin หน้ากากใบหน้าเด็กอ่อนสีม่วง',
          value: '* Fibroin หน้ากากใบหน้าเด็กอ่อนสีม่วง',
        },
        {
          address: '* Fibroin หน้ากากซ่อมแซมใบหน้าเด็กสีเขียว',
          value: '* Fibroin หน้ากากซ่อมแซมใบหน้าเด็กสีเขียว',
        },
        {
          address:'* Fibroin จิงเพียวพืชสกัด Tongyan เซรั่ม',
          value:'* Fibroin จิงเพียวพืชสกัด Tongyan เซรั่ม'
        },
         
      ]
      if(!this.$store.state.language){
        restaurants = [
 {
          address:'* 菲必丽专研口腔美白牙膏',
          value:'* 菲必丽专研口腔美白牙膏'
        },
        {
          address:'*菲必丽专研口腔防蛀牙膏',
          value:'*菲必丽专研口腔防蛀牙膏'
        },

        {
          address:'*菲必丽银色童颜保湿面膜',
          value:'*菲必丽银色童颜保湿面膜'
        },
        {
          address:'*菲必丽金色童颜水光面膜',
          value:'*菲必丽金色童颜水光面膜'
        },
        {
          address:'*菲必丽蓝色童颜保湿面膜',
          value:'*菲必丽蓝色童颜保湿面膜'
        },
        {
          address:'*菲必丽红色童颜水光面膜',
          value:'*菲必丽红色童颜水光面膜'
        },
        {
          address:'*菲必丽紫色童颜细腻面膜',
          value:'*菲必丽紫色童颜细腻面膜'
        },
        {
          address:'*菲必丽绿色童颜修护面膜',
          value:'*菲必丽绿色童颜修护面膜'
        },
        {
          address:'*菲必丽菁纯植萃童颜精华液',
          value:'*菲必丽菁纯植萃童颜精华液'
        },
       

        ]
      }
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
    },
    querySearchGpull(val){
      var restaurants = [
       {
          address:'* Fibroin ยาสีฟันขาวสูตรวิจัยพิเศษ',
          value:'* Fibroin ยาสีฟันขาวสูตรวิจัยพิเศษ'
        },
          {
          address:'* Fibroin ยาสีฟันป้องกันฟันผุ สูตรวิจัยพิเศษ',
          value:'* Fibroin ยาสีฟันป้องกันฟันผุ สูตรวิจัยพิเศษ'
        },
     {
       address:'* Fibroin หน้ากากดูแลความชุ่มชื้นเด็กสีเงิน ',
       value:'* Fibroin หน้ากากดูแลความชุ่มชื้นเด็กสีเงิน ',
     },
     {
       address:'* Fibroin หน้ากากใบหน้าเด็กสีทอง Waterlight',
       value:'* Fibroin หน้ากากใบหน้าเด็กสีทอง Waterlight',
     },
     {
       address: '* Fibroin มาสก์หน้าชุ่มชื้นสีฟ้าสำหรับเด็ก',
       value: '* Fibroin มาสก์หน้าชุ่มชื้นสีฟ้าสำหรับเด็ก',
     },
     {
       address:'* Fibroin หน้ากากใบหน้าเด็กสีแดงน้ำ',
       value:'* Fibroin หน้ากากใบหน้าเด็กสีแดงน้ำ',
     },
     {
       address: '* Fibroin หน้ากากใบหน้าเด็กอ่อนสีม่วง',
       value: '* Fibroin หน้ากากใบหน้าเด็กอ่อนสีม่วง',
     },
     {
       address: '* Fibroin หน้ากากซ่อมแซมใบหน้าเด็กสีเขียว',
       value: '* Fibroin หน้ากากซ่อมแซมใบหน้าเด็กสีเขียว',
     },
     {
       address:'* Fibroin จิงเพียวพืชสกัด Tongyan เซรั่ม',
       value:'* Fibroin จิงเพียวพืชสกัด Tongyan เซรั่ม'
     },
   ]
   if(!this.$store.state.language){
        restaurants = [
          {
          address:'* 菲必丽专研口腔美白牙膏',
          value:'* 菲必丽专研口腔美白牙膏'
        },
        {
          address:'*菲必丽专研口腔防蛀牙膏',
          value:'*菲必丽专研口腔防蛀牙膏'
        },
        {
          address:'*菲必丽银色童颜保湿面膜',
          value:'*菲必丽银色童颜保湿面膜'
        },
        {
          address:'*菲必丽金色童颜水光面膜',
          value:'*菲必丽金色童颜水光面膜'
        },
        {
          address:'*菲必丽蓝色童颜保湿面膜',
          value:'*菲必丽蓝色童颜保湿面膜'
        },
        {
          address:'*菲必丽红色童颜水光面膜',
          value:'*菲必丽红色童颜水光面膜'
        },
        {
          address:'*菲必丽紫色童颜细腻面膜',
          value:'*菲必丽紫色童颜细腻面膜'
        },
        {
          address:'*菲必丽绿色童颜修护面膜',
          value:'*菲必丽绿色童颜修护面膜'
        },
        {
          address:'*菲必丽菁纯植萃童颜精华液',
          value:'*菲必丽菁纯植萃童颜精华液'
        },
       

        ]
      }
      for (let index = 0; index < restaurants.length; index++) {
        const element = restaurants[index];
        if(element.value ==val ){
          setTimeout(()=>{
          window.scrollTo({
           top:index==0 ? 750:800+((index)*890),
          left:0,
          behavior: "smooth"
        });
        },500)
        }
      }
    },
    createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
    onImageLoad(index) {
      this.imagesLoadedCount++;
      if (this.imagesLoadedCount === this.ImageList.length) {
        setTimeout(()=>{
          this.imagesLoaded = true;
          if (this.imageLoadFallbackTimer) {
            clearTimeout(this.imageLoadFallbackTimer);
          }
        },1500)
      
      }
    },
    setIskeyPath() {
      const iskeyPath = localStorage.getItem("keyPath");
      if (iskeyPath) {
        this.activeIndex = iskeyPath;
      }
    },
    handleScroll() {
      if (window.scrollY > 100) {
        // 根据需要设置滚动多少距离后触发固定效果
        console.log("根据需要设置滚动多少距离后触发固定效果",this.$route.path);
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
      if(this.$route.path == '/pc/home'){
        if(window.scrollY < 400){
        this.activeIndex = '1'
      }
      if(window.scrollY > 650){
        this.activeIndex = '1.2'
      }
      if(window.scrollY > 7500){
        this.activeIndex = '1.3'
      }
      if(window.scrollY > 9000){
        this.activeIndex = '1.4'
      }
      }

      if(this.$route.path == '/pc/entry'){
        if(window.scrollY < 1200){
        this.activeIndex = '4'
      }
      if(window.scrollY > 1300){
        this.activeIndex = '4.2'
      }
      // if(window.scrollY > 1550){
      //   this.activeIndex = '1.3'
      // }
      }
     
    },
    // pc端跳转
    handleSelect(key, keyPath) {
      if (key == "1") {
        this.$router.push("/pc/home");
        setTimeout(()=>{
          window.scrollTo({
           top:0,
          left:0,
          behavior: "smooth"
        });
    },500)
       
        localStorage.setItem("keyPath", key);
      }  else if (key == "1.2") {
        this.$router.push("/pc/home");
        setTimeout(()=>{
          window.scrollTo({
           top:700,
          left:0,
          behavior: "smooth"
        });
    },500)
       
        
        localStorage.setItem("keyPath", key);
      } else if (key == "1.3") {
        this.$router.push("/pc/home");
        setTimeout(()=>{
          window.scrollTo({
           top:7800,
          left:0,
          behavior: "smooth"
        });
        },500)
       
        localStorage.setItem("keyPath", key);
      }
      else if (key == "1.4") {
        this.$router.push("/pc/home");
        setTimeout(()=>{
          window.scrollTo({
           top:13000,
          left:0,
          behavior: "smooth"
        });
        },500)
     
        localStorage.setItem("keyPath", key);
      }
      else if (key == "2") {
        this.$router.push("/pc/verify");
        localStorage.setItem("keyPath", key);
      } else if (key == "3") {
        this.$router.push("/pc/brandhistory");
        localStorage.setItem("keyPath", key);
      } else if (key == "4") {
        this.$router.push("/pc/entry");
        setTimeout(()=>{
          window.scrollTo({
           top:600,
          left:0,
          behavior: "smooth"
        });
        },500)
       
        localStorage.setItem("keyPath", key);
      } else if (key == "4.2") {
        this.$router.push("/pc/entry");
        setTimeout(()=>{
          window.scrollTo({
           top:1350,
          left:0,
          behavior: "smooth"
        });
        },500)
      
        localStorage.setItem("keyPath", key);
      }
    },
    //导航页面跳转
    handleCommand(command) {
      if (command == "a") {
        this.$router.push("/app/home");
      } else if (command == "b") {
        this.$router.push("/app/verify");
      } else if (command == "c") {
        console.log(123);
        this.$router.push("/app/brandhistory");
      } else if (command == "d") {
        this.$router.push("/app/entry");
      }
    },
    zt() {
      this.$store.state.language = !this.$store.state.language;
      console.log(this.$store.state.language);
    },
    /**
     * 设置轮播图
     */
    setBackgckImage(){
      let imageList = [
        "@/assets/微信图片_20250426140810.jpg",
        "@/assets/微信图片_20250426142653.jpg",
      ];
      let jiTime = 0;
      let jiLest = imageList.length;
      var element = document.querySelector('.pcRoot_Boox');
      setInterval(function() {
        if(jiTime == jiLest){
          jiTime = 0;
        }
        // console.log("查看图片",imageList[jiTime]);
        // element.style.backgroundImage = "url("+imageList[jiTime]+")";
        element.style.backgroundImage = "url(require("+imageList[jiTime]+"))";
        jiTime ++;
}, 6000);
    },
  },
  computed: {
    currentPath() {
      this.setIskeyPath();
      // console.log("路由变化", this.$route.path);
      return this.$route.path;
    },
  },
};
</script>
<style  scoped>
.hoemBox{
  width: 1240px;
  margin: auto;
}
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

nav {
  padding: 30px;
  background-color: #fff;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.header {
  /* height: 60px;
  background-color: #f0f0f0; */
  transition: all 1s ease;
  width: 100%;
}

.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: all 1s ease;
  background-color: #fff;
}
.aheader {
  background-color: #fff;
  width: 100vw;
  height: 60px; /* 调整高度以适配移动端 */
  line-height: 60px; /* 垂直居中 */
  text-align: center; /* 水平居中 */
}

.logo {
  font-family: "Malgun Gothic"; /* 设置字体 */
  font-size: 24px; /* 调整字体大小 */
  color: #000; /* 字体颜色 */
}
.pcRoot_Boox {
  position: relative;
  height: 120px;
  z-index: 999;
}
.pcRoot {
  /* opacity: 0; */
  height: 120px;
  position: fixed;
  width: 100%;
  z-index: 9999;
  /* background-color: transparent !important; */
}
.app_boox {
  position: relative;
  height: 46px;
  z-index: 999;
}
.app_root {
  height: 46px;
  position: fixed;
  width: 100%;
  display: block;
}
.pcRoot_Boox{
  width: 100vw;
  height: 70vh;
  background-image: url('@/assets/微信图片_20250426140810.jpg');
  background-repeat: no-repeat;
  /* background-repeat: repeat-y; */
  background-position: center center; /* 控制图片位置 */
  background-size: cover; 
}
::v-deep .van-nav-bar{
  /* background-color: transparent !important; */
}
.el-menu-demo{
  /* background-color: transparent !important;
  border:none; */
  width: 100%;
  /* height: 89px; */
}
::v-deep .el-menu{
  /* border:none; */
}
.el-menu--horizontal > .el-menu-item {
  /* border-bottom: none;
  text-decoration: none; */
}
.Fibroin{
  font-size: 30px;
  padding: 20px 0px;
   background-color: transparent !important;
  /* color: #fff; */
}
.grid-content{
  cursor: pointer;
  padding: 10px 0px;
  font-weight: bolder;
}
.grid-conten :hover {
  background-color: #45a049 !important;
}
.boxdsd{
  height: 70px;
}
.homeTime{
	position: absolute;
	width: 70vw;

	top: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  text-align: center;
  font-size: 2vh;
  min-font-size: 16px;
  max-font-size: 36px;

}
.box-card{

height: 16vh;

overflow: hidden; /* 隐藏溢出内容 */
text-overflow: ellipsis; /* 显示省略号 */
/* color: #d04232; */
font-weight: bolder;
font-family: "仿宋";

line-height: 4vh;
padding: 0px 6vw;

}
.secar{
  line-height: 8vh;
 
  
}
.secarItem{
    
  }
.HomeBoxdddd{
  position: relative;
}
.HomeBoxddddBuroo{
  margin-bottom: 16vh;
}
.secarItem{
  width: 100%;
}
</style>
